import React, { FC, useEffect } from 'react';
import { Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { SurchargeAmountType, SurchargeType } from '../../../../shared/orders/model';
import { InlineHelp } from '../../../components';
import { useTranslation } from '../../../translations';
import { useConfig, useInputState } from '../../../utils';

interface Props {
  readonly wide?: boolean;
}

export const SurchargeForm: FC<Props> = ({ wide }) => {
  const { ts } = useTranslation();
  const { currencySymbol } = useConfig();
  const [type, setType] = useInputState<SurchargeType>('surcharge');
  const [amountType, setAmountTypeEv, setAmountType] = useInputState<SurchargeAmountType>('fixed');

  const isFixed = amountType === 'fixed';
  const isTax = type === 'tax';

  useEffect(() => {
    if (isTax) {
      setAmountType('percent');
    }
  }, [type]);

  return (
    <Row>
      <Col lg={wide && 6} xs={12}>
        <FormGroup>
          <Label for="name">{ts('name')}</Label>
          <Input id="name" name="name" placeholder={ts('surcharge')} required />
        </FormGroup>
      </Col>
      <Col lg={wide && 6} xs={12}>
        <FormGroup>
          <Label for="name">{ts('common.display_name')}</Label>
          <Input
            id="displayName"
            name="displayName"
            placeholder={ts('common.display_name')}
            required
          />
        </FormGroup>
      </Col>
      <Col lg={wide && 6} xs={12}>
        <FormGroup>
          <Label for="type">
            {ts('type')}
            <InlineHelp>
              <Label>{ts('surcharge_type_information')}</Label>
              <ul className="flushLeft">
                <li>
                  <strong>{ts('surcharge')}</strong>: {ts('surcharge_description')}
                </li>
                <li>
                  <strong>{ts('tax_rate')}</strong>: {ts('tax_rate_description')}
                </li>
              </ul>
            </InlineHelp>
          </Label>
          <Input id="type" name="type" onChange={setType} required type="select">
            <option value="surcharge">{ts('surcharge')}</option>
            <option value="tax">{ts('tax_rate')}</option>
          </Input>
        </FormGroup>
      </Col>
      <Col lg={wide && 6} xs={12}>
        <FormGroup>
          <Label for="amountType">{ts('amount_type')}</Label>
          <Input
            id="amountType"
            name="amountType"
            onChange={setAmountTypeEv}
            required
            type="select"
            value={isTax || !isFixed ? 'percent' : 'fixed'}
          >
            <option disabled={isTax} value="fixed">
              {ts('fixed_amount')}
            </option>
            <option value="percent">{ts('percentage')}</option>
          </Input>
        </FormGroup>
      </Col>
      <Col lg={wide && 6} xs={12}>
        <FormGroup>
          <Label for="amount">{ts('common.amount')}</Label>
          <InputGroup>
            {isFixed && <InputGroupText>{currencySymbol}</InputGroupText>}
            <Input
              id="amount"
              max={isFixed ? undefined : '100'}
              min="0.01"
              name="amount"
              required
              step="0.01"
              type="number"
            />
            {!isFixed && <InputGroupText>%</InputGroupText>}
          </InputGroup>
        </FormGroup>
      </Col>
    </Row>
  );
};
